//eslint-disable-next-line
export const YOUTUBELINKREG = /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/;
export const ALPHANUMERICREG = /^[a-zA-Z0-9\s]*$/;
export const ALPHAREG = /^[a-zA-Z\s]*$/;